import { VisitAnesthesiaFormPreOpModel, IVisitAnesthesiaFormPreOpModel, VisitAnesthesiaFormSurgeryModel, IVisitAnesthesiaFormSurgeryModel, VisitAnesthesiaFormPostSurgeryModel, IVisitAnesthesiaFormPostSurgeryModel, IModel, Model, ModelRecord } from "@common/models"

export interface IVisitAnesthesiaFormModel extends IModel {
    visitAnesthesiaFormId: number;
    visitId: number;
    petId: number;
    preOp: IVisitAnesthesiaFormPreOpModel;
    surgery: IVisitAnesthesiaFormSurgeryModel;
    postSurgery: IVisitAnesthesiaFormPostSurgeryModel;
}

export class VisitAnesthesiaFormModel extends Model implements ModelRecord<IVisitAnesthesiaFormModel> {
    visitAnesthesiaFormId: number
    visitId: number
    petId: number
    preOp: VisitAnesthesiaFormPreOpModel;
    surgery: VisitAnesthesiaFormSurgeryModel;
    postSurgery: VisitAnesthesiaFormPostSurgeryModel;

    constructor(params?: Partial<IVisitAnesthesiaFormModel>) {
        super(params);
        this.visitAnesthesiaFormId = _.defaultTo(params?.visitAnesthesiaFormId, 0);
        this.visitId = _.defaultTo(params?.visitId, 0);
        this.petId = _.defaultTo(params?.petId, 0);
        this.preOp = params?.preOp ? new VisitAnesthesiaFormPreOpModel(params.preOp) : new VisitAnesthesiaFormPreOpModel();
        this.surgery = params?.surgery ? new VisitAnesthesiaFormSurgeryModel(params.surgery) : new VisitAnesthesiaFormSurgeryModel();
        this.postSurgery = params?.postSurgery ? new VisitAnesthesiaFormPostSurgeryModel(params.postSurgery) : new VisitAnesthesiaFormPostSurgeryModel();
    }

}
